webpackJsonp([1,2],{

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',

  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
  }
};

/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_content__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__i18n_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hanabi__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hanabi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hanabi__);










var comment = '<!-- generated by https://we-plugin.github.io/issue-generator/ DO NOT REMOVE -->';

__WEBPACK_IMPORTED_MODULE_5_marked___default.a.setOptions({
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: true,
  smartLists: true,
  smartypants: false,
  highlight: function highlight(code) {
    return __WEBPACK_IMPORTED_MODULE_6_hanabi___default()(code);
  }
});

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'content',

  data: function data() {
    var repo = this.$route.query.repo;

    var queryRepo = '';
    if (repo === 'element') {
      queryRepo = 'Element UI';
    } else if (repo === 'mint') {
      queryRepo = 'Mint UI';
    }

    return {
      form: {
        repo: queryRepo,
        title: '',
        type: '',
        desc: '',
        versionRepository: '',

        reproduce: '',
        steps: '',
        expected: '',
        actual: '',
        existingComponent: true,
        componentName: ''
      },
      query: {
        repo: queryRepo
      },
      show: false,
      loading: {
        repository: false,
        vue: false
      },
      version: {
        repo: [],
        vue: []
      },
      issue: ''
    };
  },


  computed: {
    lang: function lang() {
      return this.$route.path.split('/')[1] || window.navigator.language;
    },
    contents: function contents() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3__i18n_content___default.a.filter(function (c) {
        return c.lang === _this.lang;
      })[0];
    },
    api: function api() {
      return {
        repositoryVersion: 'https://registry.npm.taobao.org/' + (this.repo && this.repo.npm)
      };
    },
    isBug: function isBug() {
      return !this.contents.issueTypes.indexOf(this.form.type);
    },
    rules: function rules() {
      var _this2 = this;

      var valid = this.contents.valid;
      var rules = {};
      for (var prop in valid) {
        rules[prop] = [{
          required: true,
          trigger: 'change',
          message: valid[prop]
        }];
      }

      rules['reproduce'].push({
        trigger: 'blur',
        validator: function validator(rule, val, cb) {
          if (/(github|jsfiddle|codepen|jsbin)/ig.test(val)) {
            cb();
          } else {
            cb({
              'zh-CN': '请填写正确的重现链接',
              'en-US': 'Please provide correct link'
            }[_this2.lang]);
          }
        }
      });

      return rules;
    },
    repo: function repo() {
      var _this3 = this;

      return this.contents.repos.filter(function (r) {
        return r.name === _this3.form.repo;
      })[0];
    },
    issueHTML: function issueHTML() {
      return __WEBPACK_IMPORTED_MODULE_5_marked___default()(this.issue);
    },
    title: function title() {
      var prefix = '[' + (this.isBug ? 'Bug Report' : 'Feature Request') + '] ';
      return encodeURIComponent(prefix + this.form.title).replace(/%2B/gi, '+');
    },
    body: function body() {
      var issue = '\n' + comment + '\n\n' + this.issue + '\n\n' + comment + '\n';
      return encodeURIComponent(issue).replace(/%2B/gi, '+');
    }
  },

  watch: {
    lang: {
      handler: function handler() {
        var _this4 = this;

        this.$nextTick(function () {
          _this4.$refs.form.resetFields();
          _this4.form.repo = _this4.query.repo || _this4.contents.repos[0].name;
          _this4.form.versionRepository = _this4.version.repo[0];
          _this4.form.versionVue = _this4.version.vue[0];
          _this4.form.type = _this4.contents.issueTypes[0];
        });
      },

      immediate: true
    },

    'form.repo': {
      handler: function handler() {
        this.fetchRepositoryVersion();
      },

      immediate: true
    },

    '$route.query': {
      handler: function handler(val) {},

      immediate: true
    }
  },

  methods: {
    preview: function preview() {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this5.createIssue();
        }
      });
    },
    create: function create() {
      window.open('https://github.com/' + this.repo.github + '/issues/new?title=' + this.title + '&body=' + this.body);
    },
    createIssue: function createIssue() {
      this.issue = this.isBug ? ('\n### ' + this.form.repo + ' \u7248\u672C\n' + this.form.versionRepository + '\n\n### \u5BF9\u5E94\u5DE5\u5177\u6216\u8005iOS\u6216\u8005Andriod\u7684\u7248\u672C\u53F7\n' + this.form.versionBrowser + '\n\n### \u5FAE\u4FE1\u7248\u672C\u53F7\n' + this.form.versionWechat + '\n\n### \u91CD\u73B0\u6B65\u9AA4\n' + this.form.steps + '\n\n### \u671F\u5F85\u7684\u884C\u4E3A\n' + this.form.expect + '\n\n### \u5B9E\u9645\u7684\u884C\u4E3A\n' + this.form.actual + '\n').trim() : ('\n\n### \u63CF\u8FF0\n' + this.form.desc + '\n').trim();
      this.show = true;
    },
    fetchRepositoryVersion: function fetchRepositoryVersion() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this6.api.repositoryVersion);

              case 2:
                response = _context.sent;

                _this6.version.repo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.versions);
                _this6.form.versionRepository = _this6.version.repo[0];

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    fetchVueVersion: function fetchVueVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(_this7.api.vueVersion);

              case 2:
                response = _context2.sent;

                _this7.version.vue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data.versions);
                _this7.form.versionVue = _this7.version.vue[0];

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    }
  },

  mounted: function mounted() {}
};

/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'header',

  data: function data() {
    return {
      language: ''
    };
  },


  computed: {
    lang: function lang() {
      return this.$route.path.split('/')[1] || window.navigator.language;
    }
  },

  watch: {
    lang: {
      handler: function handler(val) {
        this.language = val;
      },

      immediate: true
    }
  }
};

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "default-active": _vm.language,
      "router": true
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/we-plugin",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("we-plugin issue")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 18,
      "sm": 18,
      "md": 12
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.intro)
    }
  }), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.repoSelectHint,
      "prop": "repo"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.repo),
      callback: function($$v) {
        _vm.form.repo = $$v
      },
      expression: "form.repo"
    }
  }, _vm._l((_vm.contents.repos), function(repo, index) {
    return _c('el-option', {
      key: repo.github,
      attrs: {
        "label": repo.name,
        "value": repo.name
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTypesHint,
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.form.type = $$v
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.contents.issueTypes), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": type,
        "value": type
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTitleHint,
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  })], 1), (_vm.isBug) ? [_c('el-form-item', [_c('small', [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueUsage)
    }
  }), _c('ul', _vm._l((_vm.contents.links[_vm.form.repo]), function(l) {
    return _c('li', {
      key: "l.link"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(l.desc)
      }
    }), _c('a', {
      attrs: {
        "href": l.link
      },
      domProps: {
        "textContent": _vm._s(l.link)
      }
    })])
  })), _c('b', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueHint)
    }
  })])]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionRepositoryHint,
      "prop": "versionRepository"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "filterable": "filterable",
      "loading": _vm.loading.repository,
      "no-match-text": _vm.contents.noMatchText,
      "no-data-text": _vm.contents.noDataText,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.versionRepository),
      callback: function($$v) {
        _vm.form.versionRepository = $$v
      },
      expression: "form.versionRepository"
    }
  }, _vm._l((_vm.version.repo), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }))], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionBrowserHint,
      "prop": "versionBrowser"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.versionBrowser),
      callback: function($$v) {
        _vm.form.versionBrowser = $$v
      },
      expression: "form.versionBrowser"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionWechatHint,
      "prop": "versionWechat"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.versionWechat),
      callback: function($$v) {
        _vm.form.versionWechat = $$v
      },
      expression: "form.versionWechat"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.stepsHint,
      "prop": "steps"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.steps),
      callback: function($$v) {
        _vm.form.steps = $$v
      },
      expression: "form.steps"
    }
  })], 1), _c('el-form-item', [_c('small', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.stepsHintSmall)
    }
  })]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.expectHint,
      "prop": "expect"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.expect),
      callback: function($$v) {
        _vm.form.expect = $$v
      },
      expression: "form.expect"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.actualHint,
      "prop": "actual"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.actual),
      callback: function($$v) {
        _vm.form.actual = $$v
      },
      expression: "form.actual"
    }
  })], 1)] : [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.descHint,
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.form.desc = $$v
      },
      expression: "form.desc"
    }
  })], 1)], _c('el-form-item', {
    staticClass: "center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.preview)
    },
    on: {
      "click": _vm.preview
    }
  })], 1)], 2)], 1)], 1), _c('el-dialog', {
    attrs: {
      "title": _vm.contents.dialog.title
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.issueHTML)
    }
  }), _c('span', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.dialog.button)
    },
    on: {
      "click": _vm.create
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

module.exports = [
	{
		"lang": "zh-CN",
		"intro": "",
		"repoSelectHint": "选择要提交 issue 的库",
		"repos": [
			{
				"name": "we-cropper",
				"github": "we-plugin/we-cropper",
				"npm": "we-cropper"
			},
			{
				"name": "we-swiper",
				"github": "we-plugin/we-swiper",
				"npm": "we-swiper"
			}
		],
		"issueTitleHint": "Issue 标题",
		"issueTypesHint": "Issue 类别",
		"issueTypes": [
			"Bug",
			"新特性"
		],
		"issueUsage": "Issue 是用作提交 Bug 以及请求新特性的，对于简单的问题，请查阅以下资源：",
		"links": {
			"Element UI": [
				{
					"desc": "官网：",
					"link": "http://element.eleme.io/#/zh-CN"
				},
				{
					"desc": "文档：",
					"link": "http://element.eleme.io/#/zh-CN/component/"
				},
				{
					"desc": "常见问题：",
					"link": "https://github.com/ElemeFE/element/blob/dev/FAQ.md#常见问题"
				},
				{
					"desc": "SegmentFault：",
					"link": "https://segmentfault.com/t/element"
				},
				{
					"desc": "Gitter：",
					"link": "https://gitter.im/ElemeFE/element"
				}
			],
			"Mint UI": [
				{
					"desc": "官网：",
					"link": "https://github.com/ElemeFE/mint-ui"
				}
			]
		},
		"issueHint": "在提交 issue 前，请先进行搜索来保证没有类似的 issue。",
		"versionRepositoryHint": "项目版本",
		"versionRepositoryHintSmall": "请检查在最新版本中能否重现此 issue。",
		"versionBrowserHint": "对应工具或者iOS或者Andriod的版本号",
		"versionWechatHint": "微信版本号",
		"versionVueHint": "Vue 版本",
		"reproduceHint": "重现链接",
		"reproduceHintSamll": "请提供可以重现 issue 的链接或者项目，例如：",
		"reproduceLinks": [
			{
				"name": "jsfiddle",
				"link": "https://jsfiddle.net/mmx38qxw/"
			}
		],
		"stepsHint": "重现步骤",
		"stepsHintSmall": "<p>请清晰的描述重现该 issue 的步骤，没有清晰重现步骤的 issue 将不会被修复。标有<code>need repro</code>的 issue 如果在 7 天内不提供相关步骤，将直接被关闭。</p>",
		"expectHint": "期待的行为",
		"actualHint": "实际的行为",
		"descHint": "Issue 描述",
		"preview": "预览",
		"valid": {
			"repo": "请选择库名",
			"title": "请填写 issue 标题",
			"type": "请选择 issue 类别",
			"versionRepository": "请选择项目的版本",
			"versionBrowser": "请填写对应工具或者iOS或者Andriod的版本号",
			"versionWechat": "请填写微信版本号",
			"reproduce": "请填写重现链接",
			"steps": "请填写重现步骤",
			"expect": "请填写期待的行为",
			"actual": "请填写实际的表现",
			"desc": " 请填写描述",
			"componentName": "请填写组件名"
		},
		"loadingText": "加载中",
		"noMatchText": "无匹配数据",
		"noDataText": "无数据",
		"dialog": {
			"title": "Issue 预览",
			"button": "创建"
		},
		"existingComponentHint": "是否是已有组件？",
		"existingComponentYes": "是",
		"existingComponentNo": "否",
		"componentNameHint": "组件名"
	},
	{
		"lang": "en-US",
		"intro": "",
		"repoSelectHint": "I am opening an issue for",
		"repos": [
			{
				"name": "Element UI",
				"github": "ElemeFE/element",
				"npm": "element-ui"
			},
			{
				"name": "Mint UI",
				"github": "ElemeFE/mint-ui",
				"npm": "mint-ui"
			}
		],
		"issueTitleHint": "Issue Title",
		"issueTypesHint": "Issue Type",
		"issueTypes": [
			"Bug Report",
			"Feature Request"
		],
		"issueUsage": "The issue list of this repo is exclusively for bug reports and feature requests. For simple questions, please use the following resources:",
		"links": {
			"Element UI": [
				{
					"desc": "HomePage: ",
					"link": "http://element.eleme.io/#/en-US"
				},
				{
					"desc": "Docs: ",
					"link": "http://element.eleme.io/#/en-US/component/"
				},
				{
					"desc": "FAQ: ",
					"link": "https://github.com/ElemeFE/element/blob/dev/FAQ.md#faq"
				},
				{
					"desc": "Gitter: ",
					"link": "https://gitter.im/element-en/Lobby"
				}
			],
			"Mint UI": [
				{
					"desc": "HomePage: ",
					"link": "https://github.com/ElemeFE/mint-ui"
				}
			]
		},
		"issueHint": "Try to search for your issue, it may have already been answered or even fixed in the development branch.",
		"versionRepositoryHint": "Repository Version",
		"versionRepositoryHintSmall": "Check if the issue is reproducible with the latest stable version of Repository.",
		"versionBrowserHint": "OS / Browser Version",
		"versionVueHint": "Vue Version",
		"reproduceHint": "Reproduction Link",
		"reproduceHintSamll": "Use jsfiddle/codepen to reproduce issue. If it requires build setup, then create a project and provide a link to a repository.",
		"reproduceLinks": [
			{
				"name": "jsfiddle",
				"link": "https://jsfiddle.net/mmx38qxw/"
			}
		],
		"stepsHint": "Steps to reproduce",
		"stepsHintSmall": "<p>It is <b>required</b> that you clearly describe the steps necessary to reproduce the issue you are running into. Issues with no clear repro steps will not be triaged. If an issue labeled <code>need repro</code> receives no further input from the issue author for more than 7 days, it will be closed.</p>",
		"expectHint": "What is Expected?",
		"actualHint": "What is actually happening?",
		"descHint": "Issue Description",
		"preview": "Preview",
		"valid": {
			"repo": "Please select repo.",
			"title": "Please provide issue title.",
			"type": "Please select type of issue",
			"versionRepository": "Please select version of Repository.",
			"versionBrowser": "Please select version of OS/Browser.",
			"versionVue": "Please select version of Vue.",
			"reproduce": "Please provide reproduction link.",
			"steps": "Please provide steps to reproduce.",
			"expect": "Please provide what is expected?",
			"actual": "Please provide what is actually happening?",
			"desc": " Please provide description.",
			"componentName": "Please provide the name of component."
		},
		"loadingText": "loading",
		"noMatchText": "no matching data",
		"noDataText": "no data",
		"dialog": {
			"title": "Issue Preview",
			"button": "Create"
		},
		"existingComponentHint": "Existing component?",
		"existingComponentYes": "Yes",
		"existingComponentNo": "No",
		"componentNameHint": "Component Name"
	}
];

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_content__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var lang = window.navigator.language === 'zh-CN' ? 'zh-CN' : 'en-US';

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/en-US',
    name: 'en-US',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content___default.a
  }, {
    path: '/zh-CN',
    name: 'zh-CN',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content___default.a
  }, {
    path: '*',
    redirect: '/' + lang
  }]
});

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(38)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[182]);


// WEBPACK FOOTER //
// static/js/app.e14231f9876f52cd7510.js